export default __webpack_public_path__ + "static/media/infografia_tratamientos.82e09a2d.jpeg";